export const dietOptions = [
  { label: "Oral", value: "oral" },
  { label: "Enteral", value: "enteral" },
  { label: "Parenteral", value: "parenteral" },
];
export const oralDietOptions = [
  { label: "Liquid", value: "liquid" },
  { label: "Semi Solid", value: "semi_solid" },
  { label: "Soft", value: "soft" },
  { label: "Normal", value: "normal" },
];
export const liquidDietOptions = [
  { label: "Clear Liquid", value: "clear_liquid" },
  { label: "Full Liquid", value: "full_liquid" },
];
export const oralDietTypeOptions = [
  { label: "Normal", value: "normal" },
  { label: "Diabetic", value: "diabetic" },
  { label: "Renal", value: "renal" },
];
export const entrealDietOptions = [
  { label: "Continuous", value: "continuous" },
  { label: "Intermittent", value: "intermittent" },
  { label: "Bolus", value: "bolus" },
];
export const entrealFeedTypeOptions = [
  { label: "RT Feed", value: "rt_feed" },
  { label: "PEG Feed", value: "peg_feed" },
];

export const otherSpecificationsOptions = [
  { label: "Hypertensive Diet", value: "hypertensive_diet" },
  { label: "Diabetic Diet", value: "diabetic_diet" },
  { label: "Renal Diet", value: "renal_diet" },
  { label: "Diabetic Renal Diet", value: "diabetic_renal_diet" },
  { label: "Hepatic Diet", value: "hepatic_diet" },
  { label: "Normal", value: "normal" },
  { label: "High Protein", value: "high_protein" },
  { label: "Acitrom/Warfarin Diet", value: "acitrom_warfarin_diet" },
  { label: "Low Vitamin K Diet", value: "low_vitamin_k_diet" },
  { label: "Hypothyroidism Diet", value: "hypothyroidism_diet" },
  { label: "Others", value: "others" },
];

export const continuousFeedOptions = [
  { label: "Niso Gastric", value: "niso_gastric" },
  { label: "Niso Jejunal Feeds", value: "niso_jejunal_feeds" },
  { label: "PEG", value: "peg" },
  { label: "PEJ", value: "pej" },
];

export const intermittentFeedOptions = [
  { label: "NJ", value: "nj" },
  { label: "PEG", value: "peg" },
  { label: "PEJ", value: "pej" },
];

export const weightLossOptions = [
  { label: "Loss", value: "loss" },
  { label: "Gain", value: "gain" },
  { label: "NA", value: "na" },
];

export const riskFactorOptions = [
  { label: "Inadequate PO Intake", value: "inadequate_po_intake" },
  { label: "Chewing/Swallowing Problem", value: "chewing_swallowing_problem" },
  {
    label: "Knowledge/Compliance Deficit",
    value: "knowledge_compliance_deficit",
  },
  { label: "Mouth Ulcers", value: "mouth_ulcers" },
  { label: "Increased Nutrional Needs", value: "increased_nutritional_needs" },
  { label: "Abnormal Lab Values", value: "abnormal_lab_values" },
  { label: "Nausea/Vomiting", value: "nausea_vomiting" },
  { label: "Others", value: "others" },
];

export const riskOptions = [
  { label: "Minimal", value: "minimal" },
  { label: "Moderate", value: "moderate" },
  { label: "High", value: "high" },
];

export const rootFeedOptions = [
  { label: "Oro-Gastric Tube (OG)", value: "oro_gastric_tube_og" },
  { label: "Naso-Gastric Tube (RT)", value: "naso_gastric_tube_rt" },
  { label: "Feeding-Jejunostomy (FJ)", value: "feeding_jejunostomy_fj" },
  { label: "Naso-Jejunal (NJ)", value: "naso_jejunal_nj" },
  { label: "PEG", value: "peg" },
  { label: "PEJ", value: "pej" },
];

export const parentalTypeOptions = [
  {
    label: "Total Parental Nutrition (TPN)",
    value: "total_parental_nutrition",
  },
  {
    label: "Peripheral Parenteral Nutrition (PPN)",
    value: "peripheral_parenteral_nutrition",
  },
];
